import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { AppSharedUIModule } from 'app-shared-ui';
import { TranslocoRootModule } from 'app-core';

import { AuthGuard } from '../guards/auth.guard';
import { CouponsComponent } from './coupons/coupons.component';
import { PricingComponent } from './pricing/pricing.component';
import { ProductPresentationDoctorsComponent } from './product-presentation-doctors/product-presentation-doctors.component';
import { ReferralComponent } from './referral/referral.component';

@NgModule({
  declarations: [
    CouponsComponent,
    PricingComponent,
    ProductPresentationDoctorsComponent,
    ReferralComponent
  ],
  imports: [
    AppSharedUIModule,
    CommonModule,
    RouterModule.forChild([
      {
        path: 'pricing',
        component: PricingComponent,
      },
      {
        path: 'referral',
        component: ReferralComponent,
      },
      {
        path: 'coupon',
        component: CouponsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'manage/product/presentation/doctors',
        component: ProductPresentationDoctorsComponent,
        canActivate: [AuthGuard]
      },
    ]),
    MatDividerModule,
    NgxDocViewerModule,
    TranslocoRootModule,
  ],
  providers: [
  ]
})
export class OrganizationModule { }
